export enum EmailClient {
  ActiveCampaign = 'ActiveCampaign',
  MailChimp = 'MailChimp',
  ConvertKit = 'ConvertKit',
  MailerLite = 'MailerLite',
  GetResponse = 'GetResponse',
  FreshMail = 'FreshMail',
  Pipedrive = 'Pipedrive',
}
